import { ButtonHTMLAttributes } from "react";
import { ReactComponent as XIcon } from "./XIcon.svg";
import styled from "styled-components";
import { Typography } from "@mui/material";

const XLoginButton = ({
  children,
  ...props
}: ButtonHTMLAttributes<HTMLButtonElement>) => {
  return (
    <StyledButton {...props}>
      <XIcon style={{ padding: "0 10px" }} />
      <Typography
        variant="button"
        paddingRight="10px"
        textTransform="none"
        color="white"
      >
        {children}
      </Typography>
    </StyledButton>
  );
};

const StyledButton = styled.button`
  width: 100%;
  height: 50px;
  border: none;
  border-radius: 4px;
  background-color: #000;
  cursor: pointer;
  color: #fff;

  display: flex;
  justify-content: center;
  align-items: center;

  &:hover,
  &:active {
    background-color: #151515;
  }
`;

export default XLoginButton;
